import { scaleTime } from 'd3-scale';

import { type WithChildren } from '@dynatrace/strato-components/core';

import { useGridPlotSize } from '../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { TimeseriesChartXScaleContext } from '../context/TimeseriesChartXScale.context.js';
import { useCurrentDomainState } from '../hooks/store/selectors.js';
import { useMinMaxXAxis } from '../hooks/useMinMaxXAxis.js';
import { useTimeseriesZoomRanges } from '../hooks/useTimeseriesZoomRanges.js';

export const TimeseriesChartXScaleProvider = ({ children }: WithChildren) => {
  const { min, max } = useMinMaxXAxis();
  const currentDomain = useCurrentDomainState();

  const { width } = useGridPlotSize();
  const { initialZoom } = useTimeseriesZoomRanges();
  const [initialZoomMin, initialZoomMax] = initialZoom ?? [];

  const scaleDomain = [
    new Date(initialZoomMin ?? min),
    new Date(initialZoomMax ?? max),
  ];

  const currentScale = scaleTime()
    .domain(currentDomain ?? scaleDomain)
    .range([0, width]);

  const initialScale = scaleTime().domain(scaleDomain).range([0, width]);

  return (
    <TimeseriesChartXScaleContext.Provider
      value={{ initialScale, currentScale }}
    >
      {children}
    </TimeseriesChartXScaleContext.Provider>
  );
};

TimeseriesChartXScaleProvider['displayName'] = 'TimeseriesChartXScaleProvider';
